import { imgixUrl } from '@uswitch/comms-ui.image'
import React from 'react'
import { buildURL } from 'react-imgix'

import { TvService } from '~/gql/graphql'

import { TitleSection } from './sections'
import styles from './styles.module.css'

const MAX_CHANNELS = 6

const TVContent = ({ tv }: { tv: TvService }) => {
  const hasChannelCount = tv.channelCount > 0
  const hasChannels = tv.channels && tv.channels.length > 0
  const channelNames = tv.channels ? tv.channels.slice(0, MAX_CHANNELS).map((channel) => channel.name) : []
  const channelLogos = tv.channels ? tv.channels.slice(0, MAX_CHANNELS).map((channel) => channel.logo) : []

  return (
    <div className={styles.sections} data-has-border>
      {hasChannelCount && (
        <>
          <TitleSection content={{ title: `What's included` }} boldTitle />
          <TitleSection
            content={{ title: 'Number of TV channels', amount: `${tv.channelCount}+` }}
            boldAmount
            smallHeader
          />
        </>
      )}

      {hasChannels && (
        <>
          <TitleSection content={{ title: 'Selected channels' }} boldTitle />

          <p className={styles.sectionBody}>Includes:</p>

          <ul className={styles.list}>
            {channelNames.map((name, index) => (
              <li className={styles.listItem} key={index}>
                <span className={styles.item}>{name}</span>
              </li>
            ))}
          </ul>

          {channelLogos && (
            <div className={styles.logos}>
              {channelLogos.map((logo, index) => {
                const imgixSrc = `https:${imgixUrl(logo.url)}`
                const imgixSrcOptimised = buildURL(imgixSrc, { auto: 'compress' })

                return <img src={imgixSrcOptimised} alt={logo.altText} className={styles.logo} key={index} />
              })}
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default TVContent
